import RubricaElenco from './RubricaElenco';

class RubricaElencoCompatto extends RubricaElenco {

    createPdf(items){

        const columns = [
            {title: "ID", dataKey: "id"},
            {title: "Organizzazione", dataKey: "org"},
            {title: "Dipartimento", dataKey: "dip"},
            {title: "Tit", dataKey: "tit"},
            {title: "Nome", dataKey: "nome"},
            {title: "Città", dataKey: "indirizzo"},
            {title: "Telefoni", dataKey: "telefoni"},
            {title: "Email", dataKey: "email"},
            {title: "Status", dataKey: "status"},
            {title: "Note", dataKey: "note"},
            {title: "Um", dataKey: "um"},
        ];
        let rows = [];
        items.map((item) => {

            let note = '';
            note += ' ' + item.idDipartimento.idOrganizzazione.note;
            note += ' ' + item.idDipartimento.note;
            note += ' ' + item.note;

            let ogg = item;
            if (item.idDipartimento.idOrganizzazione.nome !== ''){
                ogg = item.idDipartimento.idOrganizzazione;
            }
            if (item.idDipartimento.nome !== ''){
                ogg = item.idDipartimento;
            }
            if (item.nome !== ''){
                ogg = item;
            }

            let oggum = item;
            if (item.idDipartimento.modificatoIl && item.idDipartimento.modificatoIl  > oggum.modificatoIl){
                oggum = item.idDipartimento;
            }
            if (item.idDipartimento.idOrganizzazione.modificatoIl && item.idDipartimento.idOrganizzazione.modificatoIl  > oggum.modificatoIl){
                oggum = item.idDipartimento.idOrganizzazione;
            }
            let email = (ogg.email ? ogg.email : '' );// + '/' + (ogg.pec ? ogg.pec : '-');

            let org = item.idDipartimento.idOrganizzazione.nome ? item.idDipartimento.idOrganizzazione.nome.trim()  : '--';
            let dip = item.idDipartimento.nome ? item.idDipartimento.nome.trim() : '--';
            let it = {
                id: item.idSoggetto,
                org: org, //item.idDipartimento.idOrganizzazione.nome ? item.idDipartimento.idOrganizzazione.nome + '[' + item.idDipartimento.idOrganizzazione.idOrganizzazione + ']': '--',
                dip: dip, //item.idDipartimento.nome ? item.idDipartimento.nome.trim() : '--', //item.idDipartimento.nome ? item.idDipartimento.nome + '[' + item.idDipartimento.idDipartimento + ']' : '--',
                tit: item.tit ? item.tit : '',
                nome: item.cognome + ' ' + item.nome,
                status: this.getTipoSoggettoCompatto(item),
                indirizzo: this.getCitta(ogg), //this.getIndirizzoCompleto(ogg),
                telefoni: this.getNumeriTelefono(ogg),
                fax: ogg.fax ? ogg.fax : '',
                email: email.trim(),
                note: note.trim(),
                um: this.getUltimaModifica(oggum),
            };
            rows.push(it);
            return 0;
        });

        super.createPdf(columns, rows,
            {
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'wrap',
                    fontSize: 7,
                },
                columnStyles: {
                    dip:{columnWidth: 70, overflow:'hidden'},
                    org:{columnWidth: 80, overflow:'hidden'},
                    nome:{columnWidth: 90, overflow:'hidden'},
                    indirizzo: {halign: 'left', columnWidth: 60},
                    note: {halign: 'left', columnWidth: 'auto'},
                    telefoni: {halign: 'left', columnWidth: 60},
                    email: {halign: 'left', columnWidth: 'wrap'},
                    um: {halign: 'left', columnWidth: 'wrap'},
                    status: {halign: 'center'},
                }
            });
    }

}

export default RubricaElencoCompatto;


/** WEBPACK FOOTER **
 ** ./src/pdf/RubricaElencoCompatto.js
 **/